export enum DynamicsApiUri {
  WHO_AM_I = '/api/data/v9.2/WhoAmI',
  CONTACTS = '/api/data/v9.2/contacts',
  OPPORTUNITIES = '/api/data/v9.2/opportunities',
  INCIDENTS = '/api/data/v9.2/incidents',
  LEADS = '/api/data/v9.2/leads',
}
